export var GatedVariantSetName;
(function (GatedVariantSetName) {
    GatedVariantSetName["OnboardingChecklistExperimentSeptember2024"] = "OnboardingChecklistExperimentSeptember2024";
    GatedVariantSetName["ScreenShareQualityExperimentSeptember2024"] = "ScreenShareQualityExperimentSeptember2024";
    GatedVariantSetName["NewCreatorOnboardingFebruary2025"] = "NewCreatorOnboardingFebruary2025";
})(GatedVariantSetName || (GatedVariantSetName = {}));
const implicitlyTypedVariantSets = {
    [GatedVariantSetName.OnboardingChecklistExperimentSeptember2024]: {
        space: true,
        variants: ["Control", "ChecklistAndControl", "ChecklistOnly"],
        enabled: false,
    },
    [GatedVariantSetName.NewCreatorOnboardingFebruary2025]: {
        space: false,
        variants: ["HideSkipAndNewQuestions", "Control", "NewQuestions"],
        enabled: false,
    },
    [GatedVariantSetName.ScreenShareQualityExperimentSeptember2024]: {
        space: true,
        variants: ["Control", "Fps10", "Fps15"],
        enabled: true,
        overrides: {
            "ceovuWhESqtSUWkt\\diydesignediting-HQ": "Fps15",
        },
    },
};
export const getVariantSets = () => implicitlyTypedVariantSets;
export const isValidVariantFromString = (variantSet, variant) => getVariantSets()[variantSet].variants.includes(variant);
export const getVariantValues = (variantSet) => getVariantSets()[variantSet].variants;
//# sourceMappingURL=variantSets.js.map